import { packagingLayerDescriptionsData, packagingLayerTypesData } from "./Data";

export interface PackagingLayerDescription {
    id: number;
    descriptionType: string;
    descriptionName: string;
}

export interface PackagingLayerType {
    layerType: string;
    layerName: string;
    layerDescriptions: PackagingLayerDescription[];
}

export class DeclarePackagingLayers {
    public static getAllPackagingLayers(): PackagingLayerType[] {
        const packagingLayerDesc = <PackagingLayerDescription[]>packagingLayerDescriptionsData;
        let packagingLayerTypes: PackagingLayerType[] = [];

        for (let layer of packagingLayerTypesData) {
            const descriptions = layer.layerDescriptionIds.map(id => packagingLayerDesc.first(d => d.id === id));
            packagingLayerTypes.push({ layerType: layer.layerType, layerName: layer.layerName, layerDescriptions: descriptions });
        }


        return packagingLayerTypes;
    }
}